import { useSelector } from 'react-redux';

import { getCmsSectionById, getSectionIdByGroupId } from '../../../ducks';

export const useGetSectionByGroupId = (groupId: string | undefined) => {
  const sectionId = useSelector(getSectionIdByGroupId(groupId));

  return useSelector(getCmsSectionById(sectionId ?? null));
};
